
import angular from "angular";

import SearchParsingError from "../../models/errors/SearchParsingError";
import Assert from "tbAssert";

import TokenFactories from "../../models/factories/token-factories";

const mValueTokenFactorySvc = new WeakMap();
const mScopeTokenFactorySvc = new WeakMap();
const mOpTokenFactorySvc = new WeakMap();

class SearchStringTokenizerService {
    constructor(ValueTokenFactory, ScopeTokenFactory, OpTokenFactory) {
        Assert.StrictAssert((ValueTokenFactory != null), "Assertion Failure: Missing Value Token Factory Dependency");
        Assert.StrictAssert((ScopeTokenFactory != null), "Assertion Failure: Missing Scope Token Factory Dependency");
        Assert.StrictAssert((OpTokenFactory != null), "Assertion Failure: Missing Op Token Factory Dependency");

        mValueTokenFactorySvc.set(this, ValueTokenFactory);
        mScopeTokenFactorySvc.set(this, ScopeTokenFactory);
        mOpTokenFactorySvc.set(this, OpTokenFactory);
    }

    _processSearchStringBlock(currentTokenizerState) {
        if (currentTokenizerState.currentTokenBucket.length > 0) {
            let currentTokenBucketContents = currentTokenizerState.currentTokenBucket.join("");
            let possibleOpToken = mOpTokenFactorySvc.get(this).tryBuildToken(currentTokenBucketContents);

            if (angular.isUndefined(possibleOpToken)) {
                throw new SearchParsingError("Undefined result from op token checker/builder");
            }

            if (possibleOpToken != null) {

                if (possibleOpToken.tokenParams.opType === "not") {
                    let lastToken = currentTokenizerState.tokenizerResult.pop();
                    if ((angular.isDefined(lastToken)) &&
                        (lastToken.tokenType === "opToken") &&
                        (lastToken.tokenParams.opType === "and")) {

                        lastToken.tokenParams.opType = "and not";
                        currentTokenizerState.tokenizerResult.push(lastToken);
                    }
                    else {
                        throw new SearchParsingError("\"Not\" by itself is invalid. Use \"and not\" instead, or put quotation marks around it.");
                    }
                }
                else {
                    currentTokenizerState.tokenizerResult.push(possibleOpToken);
                }
            }
            else {
                let valToken = mValueTokenFactorySvc.get(this).buildToken(currentTokenBucketContents);
                currentTokenizerState.tokenizerResult.push(valToken);
            }

            currentTokenizerState.currentTokenBucket.length = 0;
        }
    }

    _tokenizeUserSearchString(userSearchString) {

        if (!angular.isString(userSearchString)) {
            throw new TypeError("Search String Is Not A String");
        }

        let tokenSeparator = /^(?:\s|\(|\))$/;

        let searchStringArray = userSearchString.split("");
        let searchStringLength = searchStringArray.length;

        let currentTokenizerState = {
            inPhrase: false,
            currentTokenBucket: [],
            tokenizerResult: []
        };

        for (let searchStringIdx = 0; searchStringIdx < searchStringLength; ++searchStringIdx) {

            let currentCharElement = searchStringArray[searchStringIdx];

            if (currentCharElement === "\"") {
                if (currentTokenizerState.inPhrase) {
                    let phraseToken = mValueTokenFactorySvc.get(this).buildToken(currentTokenizerState.currentTokenBucket.join(""));
                    currentTokenizerState.tokenizerResult.push(phraseToken);
                    currentTokenizerState.currentTokenBucket.length = 0;
                }
                currentTokenizerState.inPhrase = !(currentTokenizerState.inPhrase);
                continue;
            }

            if (currentTokenizerState.inPhrase) {
                currentTokenizerState.currentTokenBucket.push(currentCharElement);
                continue;
            }

            if (tokenSeparator.test(currentCharElement)) {

                this._processSearchStringBlock(currentTokenizerState);

                if (currentCharElement === "(") {
                    let leftParenToken = mScopeTokenFactorySvc.get(this).buildBeginScopeToken();
                    currentTokenizerState.tokenizerResult.push(leftParenToken);
                }

                if (currentCharElement === ")") {
                    let rightParenToken = mScopeTokenFactorySvc.get(this).buildEndScopeToken();
                    currentTokenizerState.tokenizerResult.push(rightParenToken);
                }

                continue;
            }

            currentTokenizerState.currentTokenBucket.push(currentCharElement);

        }

        this._processSearchStringBlock(currentTokenizerState);

        if (currentTokenizerState.inPhrase !== false) {
            throw new SearchParsingError("Runaway phrase - missing end quotation marks");
        }

        return currentTokenizerState.tokenizerResult;
    }

    toString() {
        return "SearchStringTokenizerService";
    }

    tokenizeSearchString(searchString) {
        return this._tokenizeUserSearchString(searchString);
    }
}

SearchStringTokenizerService.$inject = [ "ValueTokenFactory", "ScopeTokenFactory", "OpTokenFactory" ];

export default angular
    .module("trackerbase-app.services.search-request-parser.search-string-tokenizer-service",[
        TokenFactories
    ])
    .service("SearchStringTokenizerService", SearchStringTokenizerService)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/search-request-parser/SearchStringTokenizerService.js
// module id = vJlO
// module chunks = 1